<template>
  <div>
    <v-footer color="white" class="mt-n4 elevation-2">
      <v-container>
        <v-row class="justify-center pb-2">
          <v-col class="text-center" cols="12" md="2" sm="12">
            <v-btn href="https://policies.pjili.com/terms/" target="_blank" text
              >Terms of use</v-btn
            >
          </v-col>
          <v-col class="text-center" cols="12" md="2" sm="12">
            <v-btn
              href="https://policies.pjili.com/privacy/"
              target="_blank"
              text
              >Privacy Policy</v-btn
            >
          </v-col>
          <v-col class="text-center" cols="12" md="2" sm="12">
            <v-btn to="mission" text>Our Mission</v-btn>
          </v-col>
          <v-col class="text-center" cols="12" md="2" sm="12">
            <v-btn href="https://careers.pjili.com/" target="_blank" text
              >Careers</v-btn
            >
          </v-col>
          <v-col class="text-center" cols="12" md="2" sm="12">
            <v-btn to="/contact" text>Contact</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center" cols="12">
            <v-btn
              v-for="link in links"
              :key="link.icon"
              class="mx-5 mb-n4"
              icon
              :href="link.url"
              target="_blank"
              exact
            >
              <v-icon size="24px">{{ link.icon }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <v-bottom-navigation class="elevation-0">
      <v-card-text class="body-1 text-center">
        &copy; {{ new Date().getFullYear() }} Pjili Corp, All rights reserved.
      </v-card-text>
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  data: () => ({
    links: [
      {
        icon: "fab fa-youtube",
        url: "https://www.youtube.com/channel/UCeVU8gt1yJHRc6krWtlqAJQ"
      },
      {
        icon: "fab fa-facebook",
        url: "https://www.facebook.com/PjiliPlus/"
      },
      {
        icon: "fab fa-linkedin",
        url: "http://linkedin.com/company/pjili"
      },
      {
        icon: "fab fa-twitter",
        url: "http://twitter.com/PjiliCorp"
      }
    ]
  })
};
</script>
